export const ACTIVATE_IWOCAPAY_DASHBOARD = 'page/IWOCAPAY_DASHBOARD [activate]';
export const DASHBOARD_READY = 'IWOCAPAY_DASHBOARD_READY';
export const DASHBOARD_ERROR = 'IWOCAPAY_DASHBOARD_ERROR';
export const SELECT_NEW_PLAN = 'SELECT_NEW_PLAN';
export const REFRESH_APPLICATIONS = 'REFRESH_APPLICATIONS';
export const UPDATE_PLANS = 'UPDATE_PLANS';
